import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from '@globalConfig';
import useDirection from "@hooks/useDirection";
var StatisticsSection = function StatisticsSection() {
  var dir = useDirection();
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  var statistics = [{
    value: "+800",
    label: tShort('statistics/cars_purchased', {
      ns: 'web_sell_trade'
    }),
    icon: CDN_LINK + "/assets/images/sell-trade/money.png"
  }, {
    value: "4.8",
    label: tShort('statistics/customer_rating', {
      ns: 'web_sell_trade'
    }),
    icon: CDN_LINK + "/assets/images/sell-trade/star.png"
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "my-8 md:my-[71px] px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto px-4 py-12 md:py-16 md:px-5 md:py-18 bg-[#3C56D4] relative overflow-hidden text-white rounded-[16px] text-center md:max-w-[954px]   md:my-18 "
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/sell-trade/left-bot-arc.png",
    alt: "",
    className: "absolute bottom-0 left-0 w-auto h-auto"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/sell-trade/right-top-arc.png",
    alt: "",
    className: "absolute top-0 right-0 w-auto h-auto"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex rtl:md:flex-row-reverse en:md:flex-row rtl:flex-col-reverse ltr:flex-col justify-center  items-start gap-8 sm:gap-12 md:gap-16 lg:gap-24 relative z-[2] max-w-[600px] mx-auto h-full '}"
  }, statistics.map(function (stat, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex md:flex-col flex-row items-center text-center flex-1",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-3 md:mb-4 flex justify-center items-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: stat.icon,
      alt: "",
      className: "w-[77px] h-[77px] object-contain block mx-auto"
    })), /*#__PURE__*/React.createElement("div", {
      className: "transform ar:md:-translate-x-1/2 en:md:translate-x-1/2 ar:-translate-x-1/4 en:translate-x-1/4 relative ar:md:left-9 en:md:right-9 "
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[24px] font-extrabold text-white mb-1 md:mb-2 leading-none items-stretch ar:text-right ar:rtl ltr:text-left ",
      dir: dir
    }, stat.value), /*#__PURE__*/React.createElement("div", {
      className: "text-[20px] font-medium text-[#B8C5D6] leading-relaxed px-1 ar:text-right ar:rtl ltr:text-left ",
      dir: dir
    }, stat.label)));
  }))));
};
export default StatisticsSection;